import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableZoomableWorkflowDrawer = (): boolean => useFeatureFlag(FeatureFlagDeclarations.zoomableWorkflowDrawer);
